import { EventRegistry } from '../../../../../domain/event/event.registry';
import { ReferenceTableEvent } from './reference-table.event';
export class ReferenceTableItemDeletedEvent extends ReferenceTableEvent {
    constructor(payload, metadata, fromPersistence) {
        super({
            subject: `reference-table/${payload.referenceTableId}/item/${payload.itemId}`,
            type: ReferenceTableItemDeletedEvent.type,
            payload,
            metadata,
            fromPersistence,
        });
    }
}
ReferenceTableItemDeletedEvent.subject = 'reference-table/aggregate/reference-table/ReferenceTableItemDeletedEvent';
ReferenceTableItemDeletedEvent.type = 'com.treeplotter.api.reference-table.item-deleted.v1';
EventRegistry.register(ReferenceTableItemDeletedEvent.type, ReferenceTableItemDeletedEvent);
//# sourceMappingURL=reference-table-item-deleted.event.js.map